import { createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'

import { OrganizationSettingPage } from '../../../../../components/OrganizationSettingPage'

const Page = (): ReactElement => {
  const { organizationId } = Route.useParams()
  return <OrganizationSettingPage organizationId={organizationId} />
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/')({
  component: Page,
})
